module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-15",
    attrs: {
      "id": "_idParaDest-9",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "PT",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The Infiltration")]), _vm._v(" "), _c('p', {
    staticClass: "PT-Date"
  }, [_vm._v("1967–January 30, 1968")]), _vm._v(" "), _c('p', {
    staticClass: "Map ParaOverride-6"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "src": "image/Hue_p2.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption ParaOverride-3"
  }, [_vm._v("The moat just outside the northeast wall of the Citadel.")]), _vm._v(" "), _c('p', {
    staticClass: "Map ParaOverride-16"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "src": "image/P3.1_Che_Thi_Mung.png"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Che Thi Mung"), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v(" (left) and Hoang Thi No, "), _c('br'), _vm._v("village teenagers with the Huong River Squad "), _c('br'), _vm._v("who fought American and ARVN forces.")]), _vm._v(" "), _c('p', {
    staticClass: "Photo"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "src": "image/P3.2_Frank_Doezema.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Frank Doezema, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("the army radioman "), _c('br'), _vm._v("who manned the guard tower at the MACV compound "), _c('br'), _vm._v("when Front troops attacked.")]), _vm._v(" "), _c('p', {
    staticClass: "Photo"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "",
      "src": "image/P3_3New.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("President Johnson "), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("and General William Westmoreland"), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v(" "), _c('br'), _vm._v("in the Rose Garden during the general’s November 1967 spizzerinctum tour.")]), _vm._v(" "), _c('p', {
    staticClass: "Photo"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "src": "image/P3.4_Nguyen_Dac_Xuan.png"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Nguyen Dac Xuan, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("the Buddhist poet who became "), _c('br'), _vm._v("a propagandist and commissar for the Front.")]), _vm._v(" "), _c('p', {
    staticClass: "Map"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "src": "image/Map2HueAreacopy.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a37cfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V45578.vue
// module id = 87
// module chunks = 0